<template>
  <svg
    class="rgfx"
    :class="'rgfx--' + level"
    :width="size"
    :height="Math.round(size * 0.78)"
    viewBox="0 0 72 56"
    aria-hidden="true"
    focusable="false"
  >
    <!-- Umriss der vollen Rolle als Maßstab -->
    <circle class="rgfx__full" cx="28" cy="28" :r="R" />
    <!-- Papierbahn zum Abschneider, mit Abschnittsmarken -->
    <g v-if="paperR > CORE + 0.5">
      <rect class="rgfx__tail" x="28" :y="28 - paperR" width="42" height="5" rx="1" />
      <line v-for="x in ticks" :key="x" class="rgfx__tick" :x1="x" :x2="x" :y1="28 - paperR" :y2="28 - paperR + 5" />
      <circle class="rgfx__paper" cx="28" cy="28" :r="paperR" />
      <circle v-for="r in rings" :key="r" class="rgfx__ring" cx="28" cy="28" :r="r" />
    </g>
    <!-- Papphülse -->
    <circle class="rgfx__core" cx="28" cy="28" :r="CORE" />
    <circle class="rgfx__hole" cx="28" cy="28" r="3.2" />
  </svg>
</template>

<script>
// Gezeichnete Thermorolle (Rollen, Kundenwunsch 27.10.2026): Seitenansicht mit Papphülse, der Wickel wird mit dem
// Rest dünner (Fläche proportional zum Rest, also Radius über die Wurzel), oben läuft die Papierbahn mit
// Abschnittsmarken zum Abschneider. Gestrichelt der Umriss der vollen Rolle als Maßstab. Rein dekorativ; Zahlen stehen
// daneben im Text. Props: share (Rest 0–1), level ('ok' | 'warn' | 'error' | 'done'), size (Breite in px).
const R = 24;
const CORE = 7.5;

export default {
  name: 'RollGraphic',
  props: {
    share: { type: Number, default: 1 },
    level: { type: String, default: 'ok' },
    size: { type: Number, default: 64 }
  },
  data() {
    return { R, CORE };
  },
  computed: {
    paperR() {
      const s = Math.max(0, Math.min(1, Number(this.share) || 0));
      return Math.sqrt(CORE * CORE + s * (R * R - CORE * CORE));
    },
    rings() {
      const out = [];
      for (let r = CORE + 4; r < this.paperR - 2; r += 4.5) {
        out.push(Math.round(r * 10) / 10);
      }
      return out;
    },
    ticks() {
      const out = [];
      for (let x = 36; x < 70; x += 6) {
        out.push(x);
      }
      return out;
    }
  }
};
</script>

<style scoped>
.rgfx {
  display: block;
  flex: none;
  overflow: visible;
}
.rgfx__full {
  fill: none;
  stroke: var(--line);
  stroke-width: 1;
  stroke-dasharray: 2 2.5;
}
.rgfx__paper,
.rgfx__tail {
  fill: var(--surface);
  stroke: var(--d-std);
  stroke-width: 1.4;
}
.rgfx__ring {
  fill: none;
  stroke: var(--line);
  stroke-width: 0.8;
}
.rgfx__tick {
  stroke: var(--line);
  stroke-width: 0.8;
}
.rgfx__core {
  fill: var(--tile);
  stroke: var(--ink-4);
  stroke-width: 1.2;
}
.rgfx__hole {
  fill: var(--surface-raised);
  stroke: var(--ink-4);
  stroke-width: 0.8;
}
.rgfx--warn .rgfx__paper,
.rgfx--warn .rgfx__tail {
  stroke: var(--st-warn);
}
.rgfx--error .rgfx__paper,
.rgfx--error .rgfx__tail {
  stroke: var(--st-late);
}
.rgfx--done .rgfx__core {
  stroke: var(--ink-3);
}
</style>
